import { createFileRoute } from "@tanstack/react-router";
import { PakistanMatrixPage } from "@/components/pakistan/PakistanMatrixPage";
import { goldRatesQueryOptions } from "@/lib/nonblocking-rates";
import { SITE_URL, DEFAULT_OG_IMAGE, hreflangLinks } from "@/lib/seo";

const PATH = "/pakistan/22k";

export const Route = createFileRoute("/pakistan/22k")({
  loader: ({ context }) => context.queryClient.prefetchQuery(goldRatesQueryOptions),
  head: () => {
    const title = `22K Gold Rate in Pakistan Today — Live Per Tola & Per Gram | 22 Carat Sona Ka Bhao (916)`;
    const description = `Live 22K (91.67% / 916) gold rate in Pakistan — jewellery-grade 22 carat sona ka bhao per tola, per 10 gram, per gram across Karachi, Lahore, Islamabad and every major sarafa bazaar. Refreshed every 10 minutes.`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:url", content: `${SITE_URL}${PATH}` },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_PK" },
        { property: "og:image", content: DEFAULT_OG_IMAGE },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
      ],
      links: [{ rel: "canonical", href: `${SITE_URL}${PATH}` }, ...hreflangLinks(PATH)],
    };
  },
  component: () => (
    <PakistanMatrixPage
      mode={{ kind: "karat", karat: "22k" }}
      h1="22K Gold Price in Pakistan Today — Live Rate"
      intro="Live 22K (91.67% pure) gold rate — Pakistan mein sabse zyada jewellery is karat mein banti hai. Har major sarafa bazaar ka rate per tola, per 10 gram aur per gram, updated every 10 minutes from international XAU/USD + USD/PKR."
    />
  ),
});